import { create } from "zustand";
import type { Session, User } from "@supabase/supabase-js";
import { isSupabaseBrowserConfigured, supabase } from "@/integrations/supabase/client";

interface AuthStore {
  user: User | null;
  session: Session | null;
  initialized: boolean;
  init: () => void;
  signOut: () => Promise<void>;
}

export const useAuth = create<AuthStore>((set, get) => ({
  user: null,
  session: null,
  initialized: false,
  init: () => {
    if (get().initialized) return;
    set({ initialized: true });

    if (!isSupabaseBrowserConfigured) {
      set({ session: null, user: null });
      return;
    }

    supabase.auth
      .getSession()
      .then(({ data }) => {
        set({ session: data.session, user: data.session?.user ?? null });
      })
      .catch(() => {
        set({ session: null, user: null });
      });

    supabase.auth.onAuthStateChange((_event, session) => {
      set({ session, user: session?.user ?? null });
    });
  },
  signOut: async () => {
    if (!isSupabaseBrowserConfigured) return;
    await supabase.auth.signOut();
  },
}));
